import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import { ProfileApprovalStatusEnum } from "@sinch/core/entities/serverEnums";
import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { ProfileReviewDialog, ProfileReviewMode } from "../ProfileReviewDialog/ProfileReviewDialog";

interface ProfileApprovalBannerProps {
  declineMessage: string | null;
  onReviewComplete: () => void;
  profileApprovalStatus: ProfileApprovalStatusEnum | `${ProfileApprovalStatusEnum}`;
  workerId: string;
}

export const ProfileApprovalBanner: FC<ProfileApprovalBannerProps> = ({
  declineMessage,
  onReviewComplete,
  profileApprovalStatus,
  workerId,
}) => {
  const { t } = useTranslation();
  const [dialogMode, setDialogMode] = useState<ProfileReviewMode | null>(null);

  const handleClose = () => {
    setDialogMode(null);
    onReviewComplete();
  };

  return (
    <>
      {profileApprovalStatus === ProfileApprovalStatusEnum.PendingReview && (
        <Alert
          action={
            <Button
              color="inherit"
              data-cy="review-profile-btn"
              onClick={() => setDialogMode("initial_review")}
              size="small"
            >
              {t("ProfileReview.reviewProfile")}
            </Button>
          }
          data-cy="profile-approval-banner"
          data-status="pending_review"
          severity="info"
        >
          {t("ProfileReview.pendingReviewBanner")}
        </Alert>
      )}

      {profileApprovalStatus === ProfileApprovalStatusEnum.PendingChanges && (
        <Alert
          action={
            <Button
              color="inherit"
              data-cy="review-changes-btn"
              onClick={() => setDialogMode("pending_changes")}
              size="small"
            >
              {t("ProfileReview.reviewChanges")}
            </Button>
          }
          data-cy="profile-approval-banner"
          data-status="pending_changes"
          severity="warning"
        >
          {t("ProfileReview.pendingChangesBanner")}
        </Alert>
      )}

      {profileApprovalStatus === ProfileApprovalStatusEnum.Declined && (
        <Alert
          action={
            <Button
              color="inherit"
              data-cy="review-profile-btn"
              onClick={() => setDialogMode("initial_review")}
              size="small"
            >
              {t("ProfileReview.reviewProfile")}
            </Button>
          }
          data-cy="profile-approval-banner"
          data-status="declined"
          severity="error"
        >
          {t("ProfileReview.declinedBanner", { message: declineMessage })}
        </Alert>
      )}

      {dialogMode !== null && <ProfileReviewDialog mode={dialogMode} onClose={handleClose} workerId={workerId} />}
    </>
  );
};
